/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mild_Green_Tiger_PaceInputs */

const en_mild_green_tiger_pace = /** @type {(inputs: Mild_Green_Tiger_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro text settings`)
};

const de_mild_green_tiger_pace = /** @type {(inputs: Mild_Green_Tiger_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intro-Text Einstellungen`)
};

/**
* | output |
* | --- |
* | "Intro text settings" |
*
* @param {Mild_Green_Tiger_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const mild_green_tiger_pace = /** @type {((inputs?: Mild_Green_Tiger_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mild_Green_Tiger_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mild_green_tiger_pace(inputs)
	return de_mild_green_tiger_pace(inputs)
});